<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
	props: {
		listaChats: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			id_usuario: this.$ls.get("user").id_usuario,
			id_empresa: this.$ls.get("user").id_empresa_fk
		}
	},

	computed: {
		sortedListaChat() {
			const sorted = [...this.listaChats];
			return sorted.sort((chatA, chatB) => moment(chatB.fecha_modificacion) - moment(chatA.fecha_modificacion));
		}
	},

	methods: {
		...mapActions("ChatModule", ["agregarFavorito", "eliminarFavorito"]),

		chatHasUnreadMessages(chat) {
			if (this.isChatGrupal(chat)) return chat.mensajes.some(msg => msg.visto_mensaje === "0" && msg.remitente.id_usuario === this.id_usuario);
			else return chat.mensajes.some(msg => msg.visto_mensaje === "0" && msg.id_destinatario === this.id_usuario);
		},
		destinatario(chat) {
			return chat.usuarios.find(user => user.id_usuario !== this.id_usuario);
		},
		chatSeleccionado(chat) {
			this.$emit('chatSeleccionado', chat);
		},

		async toggleFavorite(chat) {
			const payload = {
				id_empresa: this.id_empresa,
				id_usuario: this.id_usuario,
				id_chat: chat.id_chat,
				id_favorito: this.destinatario(chat).id_usuario
			};

			if (chat.is_favorito) {
				await this.removeFavorite(payload);
			} else {
				await this.addFavorite(payload);
			}
		},

		async addFavorite(payload) {
			const res = await this.agregarFavorito(payload);
			if (!res) {
				this.toastGenericError();
			}
		},
		
		async removeFavorite(payload) {
			const res = await this.eliminarFavorito(payload);
			if (!res) {
				this.toastGenericError();
			}
		},

		isChatGrupal(chat) {
			return !!chat.moderador;
		},

		chatFirstMessage(chat) {
			if (chat.mensajes.length === 0) return "<i>Sin mensajes</i>";
			else return chat.mensajes[0].mensaje;
		}
	}
}
</script>
<template>
	<ul class="list-group list-group-flush overflow-contacto">
		<li v-for="chat in sortedListaChat" :key="chat.id_chat" class="list-group-item list-group-item-action">
			<div class="d-flex">


				<div v-if="!isChatGrupal(chat)" class="flex-grow-1">
					<a 
						href="javascript:"
						@click="chatSeleccionado(chat)"
						class="d-flex align-items-center list-contactos-action">
						<div class="flex-shrink-0">
							<img 
								v-if="destinatario(chat).imagen_perfil"
								width="48"
								height="48"
								class="img-object-cover rounded-circle"
								:src="destinatario(chat).imagen_perfil"
								:alt="destinatario(chat) | userFullName | initials"
							>
						</div>
						<div class="flex-grow-1 ms-3">
							<p class="d-grid text-secondary mb-0">
								<strong class="ellipsis-custom"> {{ destinatario(chat) | userFullName }} </strong>
								<span class="text-secondary text-opacity-75 ellipsis-custom"> {{ chat.mensajes[0].mensaje }} </span>
							</p>
						</div>
					</a>
				</div>

				<div v-else class="flex-grow-1">
					<a 
						href="javascript:"
						@click="chatSeleccionado(chat)"
						class="d-flex align-items-center list-contactos-action">
						<div class="flex-shrink-0">
							<img 
								v-if="chat.url_img_grupo"
								width="48"
								height="48"
								class="img-object-cover rounded-circle"
								:src="chat.url_img_grupo"
								:alt="chat.nombre_grupo | initials"
							>
						</div>
						<div class="flex-grow-1 ms-3">
							<p class="d-grid text-secondary mb-0">
								<strong class="ellipsis-custom"> {{ chat.nombre_grupo }} </strong>
								<span class="text-secondary text-opacity-75 ellipsis-custom" v-html="chatFirstMessage(chat)">  </span>
							</p>
						</div>
					</a>
				</div>
				
				
				<div class="d-flex align-items-center flex-shrink-0 ms-3">
					<span v-if="chatHasUnreadMessages(chat)" class="circle-text bg-red me-1"></span>
				</div>



				<div v-if="!isChatGrupal(chat)" class="d-flex align-items-center flex-shrink-0 ms-3">
					<a @click="toggleFavorite(chat)" href="javascript:" class="fs-4 color-main" >
						<span v-if="!chat.is_favorito" :key="`nofavorite-${chat.id_chat}`" >
							<font-awesome-icon icon="fa-solid fa-star"></font-awesome-icon>
						</span>
						<span v-if="chat.is_favorito" :key="`favorite-${chat.id_chat}`" >
							<font-awesome-icon icon="fa-solid fa-angle-star" class="color-yellow"></font-awesome-icon>
						</span>
					</a>
				</div>



			</div>
		</li>
	</ul>
</template>